import React from "react";
import Banner from "@p1s/p1s-common-react/entities/Banner";
import BannerType from "@p1s/p1s-common-react/constants/BannerType";
import MaintenanceBanner from "./MaintenanceBanner";

const AvailabilityBanner = () => {
    const banner = new Banner();
    banner.bannerType = BannerType.maintenance;
    banner.iconClass = "ion-android-settings";
    banner.hasButton = false;
    banner.text = "<p>We are currently undergoing maintenance. Not all products may be available</p>";
    banner.title = "Active Maintenance";

    return (<MaintenanceBanner banner={banner} className={"active"}/>);
};

export default AvailabilityBanner;
